import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import type { ScheduledPostTarget } from 'types'
import {
  PLATFORM_CHARACTER_LIMITS,
  checkPlatformViolation,
  type PlatformLimits,
} from 'components/ValidationBanner/utils'

const CAROUSEL_UNSUPPORTED_MESSAGES: Partial<Record<ExternalIntegrationEnum, string>> = {
  [ExternalIntegrationEnum.X]: "X doesn't support carousels. This will post as a single image.",
  [ExternalIntegrationEnum.GoogleBusinessProfile]:
    "Google Business Profile doesn't support carousels. This will post as a single image.",
}

interface GetContentWarningOptions {
  isCarousel: boolean
}

export const hasCaptionOverLimit = (target: ScheduledPostTarget): boolean => {
  const platform = target.provider as PlatformLimits | undefined
  if (!platform || !(platform in PLATFORM_CHARACTER_LIMITS)) return false
  const caption = (target.target_overrides?.content as string | undefined) ?? ''
  return checkPlatformViolation(caption, platform) !== null
}

export const getContentWarning = (
  target: ScheduledPostTarget,
  { isCarousel }: GetContentWarningOptions,
): string | null => {
  if (hasCaptionOverLimit(target)) return 'Post exceeded the character limit'

  if (isCarousel) {
    const carouselMessage = CAROUSEL_UNSUPPORTED_MESSAGES[target.provider]
    if (carouselMessage) return carouselMessage
  }

  return null
}
